:host {
  display: block;
}

.search {
  position: relative;

  .search {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -2px;
    width: 36px;
    height: 36px;
    font-size: 14px;
    background: transparent;
    border: none;
  }

  .delete {
    position: absolute;
    display: none;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
    width: 36px;
    height: 36px;
    font-size: 14px;
    cursor: pointer;

    &.show {
      display: flex;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  input {
    box-sizing: border-box;
    width: calc(100% - 35px);
    min-height: 33px;
    padding-left: 35px;
    padding-right: 0;
    background: var(--color-bleached-silk);
    border: none;
    outline: none;
    font-family: var(--primary-font), sans-serif;
    font-size: 16px;

    &.focus-hider {
      caret-color: transparent;
      cursor: none;
      pointer-events: none;
    }
  }

  ::placeholder {
    font-size: 16px;
    color: var(--color-silver);
  }

  &__autocomplete {
    display: none;
    box-sizing: border-box;
    font-family: var(--primary-font);
    position: fixed;
    left: 0;
    width: 100%;
    height: auto;
    background: var(--color-white);
    z-index: 1000;
    padding: 15px;
    color: var(--color-nero);

    &.show {
      display: block;
      box-shadow: rgba(12, 17, 21, 0.1) 0px 80px 50px;

      @media (max-width: 767px) {
        overflow: scroll;
        max-height: calc(100vh - 85px);

        .hideOnMobile {
          display: none;
        }
      }

      @media (min-width: 768px) {
        display: flex;
      }
    }

    @media (min-width: 768px) {
      justify-content: center;
      width: 100%;
      max-width: 940px;
      left: 50%;
      transform: translateX(-50%);
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);
      margin-top: 10px;

      .left {
        flex: 0 0 33.3333%;
        max-width: 33.3333%;
        margin-right: 20px;

        .category-item {
          &.current {
            background-color: rgba(79, 85, 91, 0.1);
          }
        }
      }

      .right {
        flex: 0 0 calc(66.6666% - 20px);
        max-width: calc(66.6666% - 20px);

        .text-right {
          margin-top: 25px;
          text-align: right;
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        }

        .list-item {
          &.current {
            background-color: rgba(79, 85, 91, 0.1);
          }
        }

        ul {
          margin-top: -10px;
        }
      }
    }

    h2 {
      font-size: 16px;
      padding: 0;
      margin: 0;
      margin-bottom: 8px;
      border-bottom: 1px solid #000;
      text-transform: uppercase;
    }

    ul {
      padding: 0;
      margin: 0 0 20px 0;
      list-style: none;

      li {
        &.list-item {
          padding-top: 10px;
          border-bottom: 1px solid var(--color-silver);

          &:last-child {
            border-bottom: 1px solid transparent;
          }
        }

        a {
          margin-bottom: 10px;
          text-decoration: none;
          color: var(--color-nero);
          display: block;

          &:hover {
            .item-text,
            .item-flag {
              opacity: 0.7;
            }

            .item-img {
              img {
                opacity: 0.7;
              }
            }
          }

          .item {
            display: flex;
            align-items: center;

            &-img {
              flex: 0 0 60px;
              max-width: 60px;
              margin-right: 10px;

              img {
                display: block;
                width: 100%;
                max-width: 60px;
                height: auto;
                mix-blend-mode: multiply;
              }
            }

            &-text {
              flex-grow: 1;

              .item-title {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;

                @supports (-webkit-line-clamp: 2) {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: initial;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
            }

            &-flag {
              font-size: 12px;
              display: flex;
              flex-flow: column nowrap;
              align-items: flex-end;
              align-content: space-between;

              span {
                &:last-child {
                  margin-top: 5px;
                }
              }

              .flag--offer {
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                background: var(--color-livique-cherryade);
                border-radius: 5px;
                padding: 5px;
                font-family: var(--primary-font);
                font-weight: var(--font-weight-bold);
                line-height: 13px;
              }

              .flag--text-label {
                display: none;
                border: 2px solid black;
                padding: 3px 8px;
                font-weight: var(--font-weight-bold);

                @include breakpointMin('md') {
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .left {
      a:hover {
        opacity: 0.7;
      }
    }
  }
}
